export default class Constants {
    static SPAS_URL = "spas"
    static RECOGNITION_URL = "choice"
    static RIA_URL = "ria"
    static RETAIL_URL = "individual"
}